import { Caption } from "../../types";
import { Dispatch, SetStateAction } from 'react';
import { getApiUrl } from '../../config/api';

// Helper function to get authentication headers
const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  } else {
    console.warn('No auth token found - this request may fail');
  }
  
  return headers;
};

export async function fetchCaptionsFromS3(projectId: string) {
    if (!projectId) {
      console.error('No project ID provided to fetchCaptionsFromS3');
      throw new Error('No project ID provided');
    }
    
    console.log(`Fetching captions for project ID: ${projectId}`);
    
    const headers = getAuthHeaders();
    
    try {
      // First try to fetch from database
      console.log(`Trying database endpoint: /video/get-captions/${projectId}`);
      const dbResponse = await fetch(getApiUrl(`/video/get-captions/${projectId}`), {
        headers
      });
      
      if (dbResponse.ok) {
        console.log('Captions fetched from database successfully');
        return await dbResponse.json();
      }
      
      // Log detailed information about the error
      console.warn(`Database fetch failed with status: ${dbResponse.status}`);
      if (dbResponse.status === 404) {
        console.warn('Project not found in database, trying S3 fallback');
      } else if (dbResponse.status === 401) {
        console.error('Authentication failed - check auth token');
      }
      
      // Fallback to S3 if database fetch fails
      console.log(`Trying S3 endpoint: /video/get-captions-s3?path=${projectId}`);
      const s3Response = await fetch(getApiUrl(`/video/get-captions-s3?path=${projectId}`), {
        headers
      });
      
      if (!s3Response.ok) {
        console.error(`S3 fetch failed with status: ${s3Response.status}`);
        if (s3Response.status === 401) {
          console.error('Authentication failed for S3 endpoint - check auth token');
        }
        throw new Error(`Failed to fetch captions from both database and S3: ${s3Response.status}`);
      }
      
      console.log('Captions fetched from S3 successfully');
      return await s3Response.json();
    } catch (error) {
      console.error('Error fetching captions:', error);
      throw error;
    }
}

export  async function saveCaptionsToS3(projectId: string, captions: Caption[], setIsProcessing?: Dispatch<SetStateAction<boolean>> ): Promise<string> {
    //setIsProcessing(true);
    try {
    const headers = getAuthHeaders();

    const response = await fetch(getApiUrl('/video/save-captions-s3'), {
      method: 'POST',
      headers,
      body: JSON.stringify({ projectId, captions }),
    });
    if (!response.ok) {
      //setIsProcessing(false);
      if (response.status === 401) {
        console.error('Authentication failed for save captions - check auth token');
      }
      throw new Error(`HTTP error: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    console.log('Caption saved to S3 at URL:', data.url);
    //setIsProcessing(false);
    return data.url;
  } catch (error) {
    //setIsProcessing(false);
    console.error('Error saving captions:', error);
    throw error;
  }
}
